export type ReactionableType = 'Chapter' | 'News' | 'Post';

export enum ReactionType {
  Top = 'top',
  Love = 'love',
  Scared = 'scared',
  Facepalm = 'facepalm',
  Sad = 'sad',
}

export interface ReactionCounts {
  top: number;
  love: number;
  scared: number;
  facepalm: number;
  sad: number;
}

export interface ReactionRequest {
  feeling: ReactionType;
}

export interface ReactionData {
  feeling_counts: ReactionCounts;
  total_reactions: number;
  user_reaction: ReactionType | null;
}

export interface ReactionResponse {
  success: boolean;
  data: ReactionData;
}
